import { ValueOf } from '@/types/util';

export const ELoginIdType = {
  MAIL: 'メールアドレス',
  PHONE: '電話番号',
  MAIL_PHONE: 'メールアドレス・電話番号',
} as const;

export type LoginIdTypeKey = keyof typeof ELoginIdType;
export type LoginIdTypeValue = ValueOf<typeof ELoginIdType>;

export const loginIdTypeKeys = Object.keys(ELoginIdType) as LoginIdTypeKey[];

/** v-select用items */
export const loginIdTypeItems = loginIdTypeKeys
  .map((key) => ({
    title: ELoginIdType[key],
    value: key,
  }));
